module.exports = __webpack_public_path__ + "static/media/cody.8813ad2d.jpg";